import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import {
  ActivatedRouteSnapshot,
  Router,
  Routes
} from '@angular/router';
import { ProductGroup } from '../shared/model/product-group.model';
import { Product } from '../shared/model/product.model';
import { ProductService } from '../shared/services/product.service';
import { SiteService } from '../shared/services/site.service';
import { ProductComponent } from './product/product.component';

/**
 * Resolves the product for a given route.
 * @param route - The current route snapshot.
 * @returns The page
 */
export function productResolver(route: ActivatedRouteSnapshot): Product | ProductGroup {
  const document = inject(DOCUMENT);
  const siteService = inject(SiteService);
  const productService = inject(ProductService);
  const product = productService.getBySlug(route.paramMap.get('product'));
  if (!product.id) {
    inject(Router).navigate([ '/offers' ]).catch(err => console.error(err));
    return new Product();
  }
  const htmlContent = productService.translate(siteService.center()!.id, product.id, 'longDescription')
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlContent;
  let content = (tempDiv.textContent || tempDiv.innerText).slice(0, 160);
  const lastPunctuation = Math.max(content.lastIndexOf('.'), content.lastIndexOf('!'), content.lastIndexOf('?'),
    content.lastIndexOf(','), content.lastIndexOf('\n'));
  if (lastPunctuation !== -1) {
    content = content.slice(0, lastPunctuation + 1);
  }
  inject(Meta).updateTag({ name: 'description', content });
  inject(Meta).updateTag({ name: 'og:description', content });
  inject(Meta).updateTag({ name: 'twitter:description', content });
  return product
}

export const routes: Routes = [
  {
    path: ':product',
    component: ProductComponent,
    resolve: {
      product: productResolver
    }
  }
];
